export default "/images/vendor/flag-icon-css/flags/4x3/kp.svg?510d0a3c130d94bfd139f07ae3823a53";